import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  ref: "items",
  class: "user-interact-comment-item-list"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "user-interact-comment-item-header" }
const _hoisted_4 = { class: "news-interact" }
const _hoisted_5 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_6 = { class: "user-interact-comment-item-header-label" }
const _hoisted_7 = { class: "user-interact" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Löschen", -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Bearbeiten", -1)
const _hoisted_12 = { class: "user-interact-comment-item-content" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Antworten... ")
const _hoisted_15 = {
  key: 0,
  class: "user-interact-comment-item-sub-comments"
}
const _hoisted_16 = ["id"]
const _hoisted_17 = { class: "user-interact-comment-item-header" }
const _hoisted_18 = { class: "news-interact" }
const _hoisted_19 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_20 = { class: "user-interact-comment-item-header-label" }
const _hoisted_21 = { class: "user-interact" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Löschen", -1)
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Bearbeiten", -1)
const _hoisted_26 = { class: "user-interact-comment-item-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_trash_bin = _resolveComponent("trash-bin")!
  const _component_edit = _resolveComponent("edit")!
  const _component_user_likes = _resolveComponent("user-likes")!
  const _component_user_sub_comments = _resolveComponent("user-sub-comments")!
  const _component_comment_answer = _resolveComponent("comment-answer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, { name: "arrange" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (comment, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(`user-interact-comment-item`),
              id: `user-interact-comment-item-${comment.uid}`,
              key: 'user-item-' + index
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(comment.user.loginNameCut) + " • " + _toDisplayString(comment.date), 1),
                    _createElementVNode("div", _hoisted_7, [
                      (!comment.commentTrashed && _ctx.isCurrentUser(comment))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-icon user-interact-comment-item-header-buttons-button user-interact-comment-item-header-buttons-delete main",
                            onClick: ($event: any) => (_ctx.deleteComment(comment))
                          }, [
                            _createVNode(_component_trash_bin),
                            _hoisted_9
                          ], 8, _hoisted_8))
                        : _createCommentVNode("", true),
                      (!comment.commentTrashed && _ctx.isCurrentUser(comment))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-icon user-interact-comment-item-header-buttons-button user-interact-comment-item-header-buttons-edit main",
                            onClick: ($event: any) => (_ctx.editComment(comment))
                          }, [
                            _createVNode(_component_edit),
                            _hoisted_11
                          ], 8, _hoisted_10))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (!comment.commentTrashed)
                    ? (_openBlock(), _createBlock(_component_user_likes, {
                        key: 0,
                        "like-toggle-uri": _ctx.makeLikeUri(comment),
                        "liked-Users-uri": _ctx.makeLikedUsersUri(comment),
                        "analytics-uri": _ctx.makeAnalyticsUri(comment),
                        "comment-data": comment
                      }, null, 8, ["like-toggle-uri", "liked-Users-uri", "analytics-uri", "comment-data"]))
                    : _createCommentVNode("", true),
                  (comment.comments.length)
                    ? (_openBlock(), _createBlock(_component_user_sub_comments, {
                        key: 1,
                        "comment-data": comment
                      }, null, 8, ["comment-data"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: _normalizeClass(['user-interact-comment-item-content-message', { 'user-interact-comment-item-content-message--trashed' : comment.commentTrashed}])
                }, _toDisplayString(comment.text), 3),
                (!comment.commentTrashed)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn user-interact-comment-item-content-answer",
                      onClick: ($event: any) => (_ctx.addSubComment(comment))
                    }, [
                      _createVNode(_component_comment_answer),
                      _hoisted_14
                    ], 8, _hoisted_13))
                  : _createCommentVNode("", true)
              ]),
              (comment.comments.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comment.comments, (subComment) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "user-interact-comment-item user-interact-comment-item--sub",
                        id: `user-interact-comment-item-${subComment.uid}`
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", _hoisted_20, _toDisplayString(subComment.user.loginNameCut) + " • " + _toDisplayString(subComment.date), 1),
                              _createElementVNode("div", _hoisted_21, [
                                (!subComment.commentTrashed && _ctx.isCurrentUser(subComment))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "btn btn-icon user-interact-comment-item-header-buttons-button user-interact-comment-item-header-buttons-delete sub",
                                      onClick: ($event: any) => (_ctx.deleteComment(subComment))
                                    }, [
                                      _createVNode(_component_trash_bin),
                                      _hoisted_23
                                    ], 8, _hoisted_22))
                                  : _createCommentVNode("", true),
                                (!subComment.commentTrashed && _ctx.isCurrentUser(subComment))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      class: "btn btn-icon user-interact-comment-item-header-buttons-button user-interact-comment-item-header-buttons-edit sub",
                                      onClick: ($event: any) => (_ctx.editComment(subComment))
                                    }, [
                                      _createVNode(_component_edit),
                                      _hoisted_25
                                    ], 8, _hoisted_24))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            (!subComment.commentTrashed)
                              ? (_openBlock(), _createBlock(_component_user_likes, {
                                  key: 0,
                                  "like-toggle-uri": _ctx.makeLikeUri(subComment),
                                  "liked-Users-uri": _ctx.makeLikedUsersUri(subComment),
                                  "analytics-uri": _ctx.makeAnalyticsUri(subComment),
                                  "comment-data": subComment
                                }, null, 8, ["like-toggle-uri", "liked-Users-uri", "analytics-uri", "comment-data"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", {
                            class: _normalizeClass(['user-interact-comment-item-content-message', { 'user-interact-comment-item-content-message--trashed' : subComment.commentTrashed}])
                          }, _toDisplayString(subComment.text), 3)
                        ])
                      ], 8, _hoisted_16))
                    }), 256))
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_2))
          }), 128))
        ]),
        _: 1
      })
    ], 512)
  ]))
}